import React, { useState, useContext, useEffect } from "react";
import Modal from '@mui/material/Modal';
import Style from "../InkData.module.css";
import style from "../style.module.css";
import {ConfigContext, socket, InkItemDataContext, InkDefaultDataContext} from '../../../WebSocket/WebSocket';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import {filterTypeData} from '../InkData';
import {inkDataItemInterface} from '../../../types/INK';

import ProtokolText from './ProtocolText.json';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CachedIcon from '@mui/icons-material/Cached';

import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useTypeVariableStore } from "../../../WebSocket/data";
import { useTranslation } from 'react-i18next';
import { CommandData } from "./Data";


export interface clickDataInterface {
  open: boolean,
  index: number,
  deviceIndex: number,
  checked?: boolean
}

export default function ModalData({dataModal, setModal}:{dataModal:clickDataInterface, setModal:React.Dispatch<React.SetStateAction<clickDataInterface>>}){
  const [acordionState,setAcordionState] = useState<string | false>("panel1");

  const itemData = useContext(InkItemDataContext);
  const defaultData = useContext(InkDefaultDataContext);
  const { i18n, t } = useTranslation();

  function close(){
    setModal({...dataModal, open: false});
  }
  const setAcordion = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setAcordionState(isExpanded ? panel : false);
  }

  const item = itemData[dataModal.deviceIndex][dataModal.index];
  const graphics = defaultData[dataModal.deviceIndex]?.graphics;

  console.log("dataModal", dataModal)

  function type(a:number){
    switch(a){
      // signály
      case 1:
        return t("sig_SB");// "SB - 1 bitová informace poslaná hned";
      case 2: 
        return t("sig_TON"); //"TON - Zpožděné zapnutí";
      case 3:
        return t("sig_TOF"); //"TOF - Zpožděné vypnutí";
      case 4:
        return t("sig_IMP"); //"IMP - 1 impulz";
      case 5:
        return t("sig_IMP+OR"); //"IMP+OR - Impulz s případným protažením impulzu";
      case 6:
        return t("sig_DB"); //"DB - 2 bitová informace (4 stavy)";
      case 7:
        return t("sig_RL"); //"RL - Float 4 byte";
      case 8:
        return t("sig_DW"); //"DW - 4 bytové celé číslo bez znaménka";
      case 9:
        return t("sig_SN"); //"SN - 2 bytové celé číslo se znaménkem";

      // povely
      case 21:
        return t("cmd-SB"); //"SB - 1 bitový povel"
      case 26:
        return t("cmd-DB"); //"DB - 2 bitový povel"
      case 27:
        return t("cmd-RL"); //"RL - 4 bitový float"
      case 28:
        return t("cmd-DW"); //"DW - 4 bytové celé číslo bez znaménka"
      case 29:
        return t("cmd-SN"); //"SN - 2 byte číslo se znaménkem"
    }

    return t("unknown")
  }

  function stateName(){
    if(graphics[item.xmlConfig.style]?.item){
      if(graphics[item.xmlConfig.style]?.item[item.value.value]?.name){
        return graphics[item.xmlConfig.style]?.item[item.value.value]?.name
      }
    }else{
      return t("unassigned")
    }
  }

  return(
    <Modal
      open={dataModal.open}
      onClose={close}
    >
      <div className={Style.Modal}>
        <div className={Style.Modal_Header}>
          <strong>{item.inkConfig.desc}</strong>
          <Tooltip title={t("close")} placement="top" arrow>
            <IconButton component="span" onClick={close}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div className={Style.Modal_body}>
          <table>
            <tr>
              <th>{t("title")}:</th>
              <td>{item.inkConfig.desc}</td>
            </tr>
            <tr>
              <th>{t("type")}:</th>
              <td>{type(item.inkConfig.typ)}</td>
            </tr>
            <tr>
              <th>Index:</th>
              <td>{dataModal.index}</td>
            </tr>
            {item.inkConfig.typ > 0 && item.inkConfig.typ < 20 ?
              <React.Fragment>
                <tr>
                  <th>{t("value")}:</th>
                  <td>{item.value.value}</td>
                </tr>
                <tr>
                  <th>{t("quality")}:</th>
                  <td>{item.value?.quality}</td>
                </tr>
                <tr>
                  <th>{t("simulation-value")}:</th>
                  <td>{item.value?.value_t}</td>
                </tr>
                <tr>
                  <th>{t("simulation-quality")}:</th>
                  <td>{item.value?.quality_t}</td>
                </tr>
                <tr>
                  <th>{t("state")}:</th>
                  <td>{stateName()}</td>
                </tr>
              </React.Fragment>
            :""}
          </table>

          {item.xmlConfig.point?.map((number:number)=>{
            const data = itemData[dataModal.deviceIndex][number]
            if(data.inkConfig.typ  > 20 && data.inkConfig.typ < 30){
              return <Command data={data} deviceIndex={dataModal.deviceIndex} graphics={graphics} />
            }
          })}

          {item.inkConfig.typ > 0 && item.inkConfig.typ < 30 ? <Command data={item} deviceIndex={dataModal.deviceIndex} graphics={graphics} /> : ""}

          <Accordion expanded={acordionState === "panel1"} onChange={setAcordion("panel1")}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className={style.accordionSummary}
            >
              <Typography>{t("related-items")}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                {item.xmlConfig?.point ? 
                <RelatedItems inkData={itemData[dataModal.deviceIndex]} data={item} graphics={defaultData[dataModal.deviceIndex]?.graphics} />
                  : t("no-data")}
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={acordionState === "panel2"} onChange={setAcordion("panel2")}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className={style.accordionSummary}
            >
              <Typography>{t("more-information")}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <Info deviceIndex={dataModal.deviceIndex} index={dataModal.index} />
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={acordionState === "panel3"} onChange={setAcordion("panel3")}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className={style.accordionSummary}
            >
              <Typography>Log</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <Log />
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </Modal>
  );
}

function Command({data, deviceIndex, graphics}:{data:inkDataItemInterface, deviceIndex:number, graphics:any}){
  const [text,setText] = useState(0);
  const [inkSytemDataMaping] = useTypeVariableStore((state) => [state.device[deviceIndex]?.inkSytemDataMaping]);
  const [commandData, setCommandData] = useState<CommandData>({
    messageID: 5,
    messageType: "rewrite",
    data: [{ web_id: data.inkConfig.web_id, buffer_id: data.inkConfig.buffer_id, value: 0, quality: 0}]
  })
  const { i18n, t } = useTranslation();

  //const text = graphics[data.style]?.item[data.value]?.name
  console.log(inkSytemDataMaping)
  
  let povel = {
    messageID: 3,
    messageType: "command",
    data:[
      { web_id: data.inkConfig.web_id, buffer_id: data.inkConfig.buffer_id,  value: 0 }
    ]
  }

  /*let rewrite = {
    messageID: 5,
    messageType: "rewrite",
    data: [{ id: data.inkConfig.id, value: 0, qualit: 0}]
  }*/

  function buttonText(value:number){
    return graphics[data.xmlConfig.style]?.item[value]?.name
  }

  function sendCommand(){
    povel.data[0].value = text;
    socket[deviceIndex].emit("command", povel);
  }

  function comandOnOff(a:number){
    povel.data[0].value = a;
    socket[deviceIndex].emit("command", povel);
  }

  // Zapsání hodnoty
  function comandRewriteValue(a:number){
    setCommandData((orgData)=>{
      orgData.messageID = 5,
      orgData.messageType = "rewrite", 
      orgData.data[0].value = a,
      socket[deviceIndex].emit("command", orgData);
      return {...orgData}
    })
    
  }

  // Zapsání kvality
  function comandRewriteQuality(a:number){
    setCommandData((orgData)=>{
      orgData.messageID = 5,
      orgData.messageType = "rewrite", 
      orgData.data[0].quality = a,
      socket[deviceIndex].emit("command", orgData);
      return {...orgData}
    })
  }

  function setForm(event: React.ChangeEvent<HTMLInputElement>){
    let value = event.target.value;
    /*if(value.includes('.')){
      value = value + "1"
    }*/
    setText(parseFloat(value));
  }

  return(
    <React.Fragment>
      {data.inkConfig.typ === 21 ? 
        <React.Fragment>
          <Button className={Style.Modal_button} style={{ marginRight: "5px" }} variant="contained" onClick={() => { comandOnOff(1) }}>{t("turn-on")}</Button>
          <Button className={Style.Modal_button} variant="contained" onClick={() => { comandOnOff(0) }}>{t("turn-off")}</Button>
        </React.Fragment> 
      :""}
      {data.inkConfig.typ === 26 ? 
        <React.Fragment>
          <Button className={Style.Modal_button} style={{ marginRight: "5px" }} variant="contained" onClick={() => { comandOnOff(2) }}>{t("turn-on")}</Button>
          <Button className={Style.Modal_button} variant="contained" onClick={() => { comandOnOff(1) }}>{t("turn-off")}</Button>
        </React.Fragment> 
      :""}
      {data.inkConfig.typ === 27 || data.inkConfig.typ === 28 || data.inkConfig.typ === 29 ?
        <React.Fragment>
          <TextField
            label={t("number-of-switches")}
            name="turnout"
            variant="outlined"
            value={text}
            onChange={setForm}
          />
          <Button className={Style.Modal_button} variant="contained" onClick={sendCommand}>{t("send-command")}</Button>
        </React.Fragment>
      :""}

      {inkSytemDataMaping?.ink_test === 1 &&
        <React.Fragment>
          {data.inkConfig.typ === 1 || data.inkConfig.typ === 2 || data.inkConfig.typ === 3 || data.inkConfig.typ === 4 || data.inkConfig.typ === 5 ?
            <React.Fragment>
              <Button className={Style.Modal_button} style={{ marginRight: "5px" }} variant="contained" onClick={() => { comandRewriteValue(1) }}>{t("has-effect")}</Button>
              <Button className={Style.Modal_button} variant="contained" onClick={() => { comandRewriteValue(0) }}>{t("has-no-effect")}</Button>
            </React.Fragment>
            :""}
          {data.inkConfig.typ === 6 ?
            <React.Fragment>
              <Button className={Style.Modal_button} style={{ marginRight: "5px" }} variant="contained" onClick={() => { comandRewriteValue(2) }}>{t("turned-on")}</Button>
              <Button className={Style.Modal_button} variant="contained" onClick={() => { comandRewriteValue(1) }}>{t("turned-off")}</Button>
              <Button className={Style.Modal_button} style={{ marginRight: "5px" }} variant="contained" onClick={() => { comandRewriteValue(0) }}>{t("mid-position")}</Button>
              <Button className={Style.Modal_button} variant="contained" onClick={() => { comandRewriteValue(3) }}>{t("undefined-state")}</Button>
            </React.Fragment>
          :""}
          {data.inkConfig.typ === 7 || data.inkConfig.typ === 8 || data.inkConfig.typ === 9 ?
          <React.Fragment>
              <TextField
                label="Číslo"
                name="turnout"
                variant="outlined"
                value={text}
                onChange={setForm}
              />
              <Button className={Style.Modal_button} variant="contained" onClick={() => { comandRewriteValue(text) }}>{t("record-measurement")}</Button>
            </React.Fragment>
          :""}
        </React.Fragment>
      }
      {inkSytemDataMaping?.ink_test === 1 &&
        <React.Fragment>
          <Button className={Style.Modal_button} style={{ marginRight: "5px" }} variant="contained" onClick={() => { comandRewriteQuality(1) }}>{t("bad-quality")}</Button>
          <Button className={Style.Modal_button} variant="contained" onClick={() => { comandRewriteQuality(0) }}>{t("good-quality")}</Button>
        </React.Fragment>
      }
    </React.Fragment>
  );
}

function RelatedItems({data,inkData,graphics}:any){
  const { i18n, t } = useTranslation();

  return(
    <React.Fragment>
      <table>
        <thead>
          <tr>
            <th>Index</th>
            <th>{t("title")}</th>
            <th>{t("value")}</th>
          </tr>
        </thead>
        <tbody>
          {data.point.map((number:number)=>{
            const text = graphics[inkData[number].style]?.item[inkData[number].value]?.name
            return(
              <tr>
                <td>{number}</td>
                <td>{inkData[number].desc}</td>
                <td>{text ? text : inkData[number].value}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </React.Fragment>
  );
}

function Info({deviceIndex, index}:{deviceIndex:number, index:number}){
  const { i18n, t } = useTranslation();
  const request = {
    messageID: 2,
    requestID: 4,
    messageType: "request item",
    id: index
  }

  const driverInitData = { // INK => web
    messageType: "driver init",
    data:[
      { id: 0,
        name: "PLC_U1", // název driveru
        desc: t("transformer-field") + " T101", // popis driveru
        type: "iec104c", // typ driveru
        state: 0, // stav driveru (0-neběží, 1-běží, 2-chyba, 4-)
        cfid: 10, // id poruchy komunikace
        interface:{
          rport: 0, // vzdálený komunikační port
          lport: 0, // lokální komunikační port
          rip: "172.16.110.75", // vzdálená ip  
          lip: "172.16.0.20", // lokální ip
        }
      },
      {id: 1, name: "PLC_U1", desc: "něco", type: "iec104c", state: 0, interface:{
        rport: 0, // vzdálený komunikační port
        lport: 0, // lokální komunikační port
        rip: "172.16.110.75", // vzdálená ip  
        lip: "172.16.0.20", // lokální ip
      }},
      {
        id: 2, name: "ED1", desc: t("dispatching") + " 1", type: "iec104s", state: 0, interface:{
        rport: 0, // vzdálený komunikační port
        lport: 2404, // lokální komunikační port
        rip: "172.16.110.75", // vzdálená ip  
        lip: "172.16.0.20", // lokální ip
      }},
      {
        id: 3, name: "ED2", desc: t("dispatching")+" 2", type: "iec61850c", state: 0, interface:{
        rport: 0, // vzdálený komunikační port
        lport: 2404, // lokální komunikační port
        rip: "172.16.110.75", // vzdálená ip  
        lip: "172.16.0.20", // lokální ip
      }},
      {
        id: 4, name: "TS", desc: t("touch-display") + " ASX1", type: "modbus", state: 0, interface:{
        rport: 0, // vzdálený komunikační port
        lport: 1000, // lokální komunikační port
        rip: "172.16.110.75", // vzdálená ip  
        lip: "172.16.0.20", // lokální ip
      }}
    ]
  }

  const itemData = { // INK => web
    messageType: "item",
    dataTarget:[
      { id: 0,
        driverID: 2,
        conv: {id: 0, limit:[]}, 
        off_lo: null,
        lo: null,
        off_hi: null,
        hi: null,

        // povel nebo signál
        comnd:{
          cond: 0, // podmínky povelu
          lp: 0, 
          lpt: 0,
          blkcmd: 0, // blokace povelů
        },
        sig:{},
        // data protokolu
        iec104s:{
          type: 13, // typ iec104
          ioa: 4867100, // adresa 3B (ioa = ioa1 * 65536 + ioa2), (ioa = ioa1 * 65536 + ioa2 * 256 + ioa3)
          asdu: 0,
          group: 0
        }
      },
      {id: 1, conv: {id: 0, limit:[]}, 
      off_lo: null,
      lo: null,
      off_hi: null,
      hi: null,driverID: 3, // konkrétní protokol
      iec104c:{
        type: 0, // typ iec104
        ioa: 1500, // adresa 3B (ioa = ioa1 * 65536 + ioa2), (ioa = ioa1 * 65536 + ioa2 * 256 + ioa3)
        //ioa1: 0, // adresa strukturovaná 1B 
        //ioa2: 0, // adresa strukturovaná 2B
        asdu: 0,
        group: 0
      },
      iec104s:{
        type: 0,
        ioa: 1500, // adresa 3B (ioa = ioa1 * 65536 + ioa2)
        //ioa1: 0, // adresa strukturovaná 1B 
        //ioa2: 0, // adresa strukturovaná 2B
        asdu: 0,
        group: 0
      },
      iec61850c:{
        LDname: null,
        LNname: null,
        ctlModel: null,
        sync: null,
        lock: null,
        test: null
      },
      iec61850:{
        LDname: null,
        RCBname: null,
        LNname: null,
      }},
      {id: 2, conv: {id: 0, limit:[]}, 
      off_lo: null,
      lo: null,
      off_hi: null,
      hi: null,driverID: 4, MODBUS:{}},
      {id: 3, conv: {id: 0, limit:[]}, 
      off_lo: null,
      lo: null,
      off_hi: null,
      hi: null,driverID: 4, MODBUS:{}},
      {id: 4, conv: {id: 0, limit:[]}, 
      off_lo: null,
      lo: null,
      off_hi: null,
      hi: null,driverID: 4, MODBUS:{}}
    ],
    dataSource:[
      {id: 0, conv: {id: 0, limit:[]}, 
      off_lo: null,
      lo: null,
      off_hi: null,
      hi: null, driverID: 1, // konkrétní protokol
      iec104c:{
        type: 0, // typ iec104
        ioa: 1500, // adresa 3B (ioa = ioa1 * 65536 + ioa2), (ioa = ioa1 * 65536 + ioa2 * 256 + ioa3)
        //ioa1: 0, // adresa strukturovaná 1B 
        //ioa2: 0, // adresa strukturovaná 2B
        asdu: 0,
        group: 0
      },
      iec104s:{
        type: 0,
        ioa: 1500, // adresa 3B (ioa = ioa1 * 65536 + ioa2)
        //ioa1: 0, // adresa strukturovaná 1B 
        //ioa2: 0, // adresa strukturovaná 2B
        asdu: 0,
        group: 0
      }}
    ],
    config:{
  
    }
  }

  function Driver({itemData}:any){

    interface dataIEC104 {
      type: number,
      ioa: number,
      asdu: number,
      group: number
    }

    function IEC104({data}:{data:dataIEC104}){

      // ioa = ioa1 * 65536 + ioa2
      const ioa2 = data.ioa % 65536 // 2B
      const ioa1 = (data.ioa - ioa2)/65536 // 1B

      // ioa = ioa1 * 65536 + ioa2), (ioa = ioa1 * 65536 + ioa2 * 256 + ioa3
      const ioa33 = (data.ioa % 65536)%256
      const ioa22 = (data.ioa % 65536 - ioa33)/256
      const ioa11 = (data.ioa - ioa22*256 - ioa33)/65536

      let typeShortcode, typeText;

      if(ProtokolText.IEC104[data.type].shortcode){
        typeShortcode = ProtokolText.IEC104[data.type].shortcode
      }else{
        typeShortcode = t("not-defined")
      }

      if(ProtokolText.IEC104[data.type].text){
        typeText = ProtokolText.IEC104[data.type].text
      }else{
        typeText = t("not-defined")
      }

      return(
        <table>
          <thead>
            <th colSpan={6} style={{ textAlign: "center", backgroundColor: "orange" }} >{t("protocol")}</th>
          </thead>
          <tbody className={Style.Modal_body_info_protocol}>
            <tr>
              <th> IOA: </th>
              <td> {data.ioa} </td>
              <th> IOA1: </th>
              <td> {ioa1} </td>
              <th> IOA1: </th>
              <td> {ioa11} </td>
            </tr>
            <tr>
              <th> ASDU: </th>
              <td> {data.asdu} </td>
              <th> IOA2: </th>
              <td> {ioa2} </td>
              <th> IOA2: </th>
              <td> {ioa22} </td>
            </tr>
            <tr>
              <th> Group: </th>
              <td> {data.group} </td>
              <th></th>
              <td></td>
              <th> IOA3: </th>
              <td> {ioa33} </td>
            </tr>
            <tr>
              <th>{t("type")}:</th>
              <td> {data.type} - {typeShortcode} </td>
              <th></th>
              <td></td>
              <th></th>
              <td></td>
            </tr>
            <tr>
              <td colSpan={6} > {typeText} </td>
            </tr>
          </tbody>
        </table>
      )
    }

    function IEC61850s({data}:any){
      return(
        <table>
          <thead>
            <tr>
              <th colSpan={6} style={{ textAlign: "center", backgroundColor: "orange" }} >{t("protocol-not-implemented")}</th>
            </tr>
          </thead>
          <tbody>

          </tbody>
        </table>
      );
    }

    function IEC61850c({data}:any){
      return(
        <table>
          <thead>
            <tr>
              <th colSpan={6} style={{ textAlign: "center", backgroundColor: "orange" }} >{t("protocol-not-implemented")}</th>
            </tr>
          </thead>
          <tbody>
            
          </tbody>
        </table>
      );
    }

    function MODBUS({data}:any){
      return(
        <table>
          <thead>
            <tr>
              <th colSpan={6} style={{ textAlign: "center", backgroundColor: "orange" }}>{t("protocol-not-implemented")}</th>
            </tr>
          </thead>
          <tbody>
            
          </tbody>
        </table>
      );
    }
    
    return(
      <div className={Style.Modal_body_info}>
        {itemData.map(({id,driverID,conv,off_lo,lo,off_hi,hi,iec104c,iec104s,iec61850c,iec61850s,modbus}:any)=>{
          return(
            <div key={id} style={{display: "flex"}}>
              <table>
                <thead>
                  <tr>
                    <th colSpan={6} >{driverInitData.data[driverID].name} ({driverInitData.data[driverID].type})</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>{t("description")}:</th>
                    <td colSpan={5} >{driverInitData.data[driverID].desc}</td>
                  </tr>
                  <tr>
                    <th>{t("state")}:</th>
                    <td>{driverInitData.data[driverID].state}</td>
                    <th>L IP:</th>
                    <td>{driverInitData.data[driverID].interface.lip}</td>
                    <th>L Port:</th>
                    <td>{driverInitData.data[driverID].interface.lport}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <th>R IP:</th>
                    <td>{driverInitData.data[driverID].interface.rip}</td>
                    <th>R Port:</th>
                    <td>{driverInitData.data[driverID].interface.rport}</td>
                  </tr>
                  <tr>
                    <th> OFF_lo: </th>
                    <td> {off_lo} </td>
                    <th> lo: </th>
                    <td> {lo} </td>
                    <th> {t("conversion")}: </th>
                    <td> {conv.id} </td>
                  </tr>
                  <tr>
                    <th> OFF_hi: </th>
                    <td> {off_hi} </td>
                    <th> hi: </th>
                    <td> {hi} </td>
                    <th> {t("parameters")}: </th>
                    <td> {conv.limit} </td>
                  </tr>
                </tbody>
              </table>
              {driverInitData.data[driverID].type === "iec104s" ? <IEC104 data={iec104s}/> : ""}
              {driverInitData.data[driverID].type === "iec104c" ? <IEC104 data={iec104c}/> : ""}
              {driverInitData.data[driverID].type === "iec61850s" ? <IEC61850s data={iec61850s}/> : ""}
              {driverInitData.data[driverID].type === "iec61850c" ? <IEC61850c data={iec61850c}/> : ""}
              {driverInitData.data[driverID].type === "modbus" ? <MODBUS data={modbus}/> : ""}
              
            </div>
          );
        })}
      </div>
    );
  }

  return(
    <React.Fragment>
      <Tooltip title={t("send-request")} placement="top" arrow>
        <IconButton component="span" onClick={()=>{
          socket[deviceIndex].emit("request", request);
        }}>
          <CachedIcon />
        </IconButton>
      </Tooltip>
      <br></br>
      <span>{t("target")}:</span>
      <Driver itemData={itemData.dataTarget} />
      <span>{t("source")}:</span>
      <Driver itemData={itemData.dataSource} />
    </React.Fragment>
  );
}

function Log(){

  return(
    <React.Fragment>
      Log
    </React.Fragment>
  );
}

